const MODULE = 'SPECIFIC_ASSET'

export const FETCH_REQUEST = `${MODULE}/FETCH_REQUEST`
export const FETCH_SUCCESS = `${MODULE}/FETCH_SUCCESS`
export const FETCH_FAILED = `${MODULE}/FETCH_FAILED`
export const CLEAR_LIST = `${MODULE}/CLEAR_LIST`
export const CLEAR_FILTERS = `${MODULE}/CLEAR_FILTERS`
export const SET_FILTER_VALUE = `${MODULE}/SET_FILTER_VALUE`
export const STORE_ASSET_LIST = `${MODULE}/STORE_ASSET_LIST`
